export default __webpack_public_path__ + "static/media/jinyaun-1-1-point5-768x513.a9bf0cda.jpg";